<template>
  <Overlay name="contact" primary-shadow>
    <form :class="['contact', { '-loading': isSending }]" @submit.prevent="onSubmit">
      <template v-if="!isComplete">
        <header class="contact__row">
          <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
          <h2 class="contact__title">{{ $wp.title }}</h2>
          <ContentRaw :html="$wp.content" class="contact__text" />
        </header>

        <div class="contact__row">
          <h5 class="contact__heading">{{ $wp.labels.options }}</h5>
          <InputOptions v-model="model.reason" :error="getFieldError('reason')" :options="options" @focus="onFocus" />
        </div>

        <div class="contact__row -flex">
          <InputText
            v-model="model.name"
            :error="getFieldError('name')"
            :label="$wp.labels.name"
            class="contact__input"
            @focus="onFocus"
          />

          <InputText
            v-model="model.org"
            :error="getFieldError('org')"
            :label="$wp.labels.org"
            class="contact__input"
            @focus="onFocus"
          />
        </div>

        <div class="contact__row -flex">
          <InputText
            v-model="model.email"
            :error="getFieldError('email')"
            :label="emailLabel"
            class="contact__input"
            @focus="onFocus"
          />

          <InputText v-model="model.phone" :label="phoneLabel" class="contact__input" @focus="onFocus" />
        </div>

        <div class="contact__row">
          <InputTextarea
            v-model="model.message"
            :error="getFieldError('message')"
            :label="$wp.labels.message"
            class="message"
            @focus="onFocus"
          />
        </div>

        <div class="contact__row -flex -end">
          <button class="button -submit">{{ submitLabel }}</button>
        </div>
      </template>

      <ContentRaw v-else tag="h4" :html="successMessage" class="contact__heading" />

      <footer class="contact__footer">
        <p v-for="(info, icon) in $store.state.content.settings.contact" :key="icon" class="contact__info">
          <Icon :id="icon" />
          {{ info }}
        </p>

        <ul class="contact__social">
          <a
            v-for="(url, icon) in $store.state.content.settings.social"
            :key="icon"
            :href="url"
            target="_blank"
            rel="noopener"
            class="contact__social-link"
          >
            <Icon :id="icon" />
          </a>
        </ul>
      </footer>
    </form>
  </Overlay>
</template>

<script>
import axios from 'axios'
import { ContentRaw } from '@/components/content'
import { InputOptions, InputText, InputTextarea } from '@/components/controls'

export default {
  name: 'ContactForm',
  contentKey: 'contact',
  components: { InputOptions, InputText, InputTextarea, ContentRaw },
  data() {
    return {
      showValidation: false,
      isSending: false,
      isComplete: false,
      error: null,
      requiredFields: ['reason', 'name', 'org', 'email', 'message'],
      model: { reason: '', name: '', org: '', email: '', phone: '', message: '' }
    }
  },

  computed: {
    requiredErrorMessage() {
      return this.$lang.current === 'en' ? 'Required' : 'Requis'
    },
    isValidEmail() {
      return /^[^\s\n]+@[^\s\n]+\.[a-z0-9]{2,}$/.test(this.model.email)
    },
    isValid() {
      return this.isValidEmail && this.requiredFields.every(input => this.model[input].length > 0)
    },
    invalidFields() {
      return this.requiredFields.filter(input =>
        input === 'email' ? !this.isValidEmail : this.model[input] === null || this.model[input].length === 0
      )
    },
    options() {
      return this.$wp.options.split(';').map(str => str.trim())
    },
    successMessage() {
      return this.$lang.current === 'en'
        ? 'We have received your message<br>and will get back to you as soon as possible!'
        : 'Nous avons bien reçu votre message.<br>Nous vous répondrons dans les meilleurs délais!'
    },
    emailLabel() {
      return this.$lang.current === 'en' ? 'Email' : 'Courriel'
    },
    phoneLabel() {
      return this.$lang.current === 'en' ? 'Phone (optional)' : 'Téléphone (facultatif)'
    },
    submitLabel() {
      return this.$lang.current === 'en' ? 'Send' : 'Envoyer le message'
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler({ option = null }) {
        this.model.reason = this.options[option] || null
      }
    },
    model: {
      deep: true,
      handler() {
        this.showRecaptcha()
      }
    }
  },
  methods: {
    showRecaptcha() {
      document.getElementsByClassName('grecaptcha-badge')[0].style.visibility = 'visible'
    },
    getFieldError(field) {
      return this.showValidation && this.invalidFields.indexOf(field) > -1 ? this.requiredErrorMessage : null
    },
    onFocus() {
      this.showValidation = false
    },
    onSubmit() {
      if (this.isSending) return
      if (this.isValid) return this.sendForm()
      this.showValidation = true
      console.log('Missing fields:', this.invalidFields.join(' | '))
    },
    sendForm() {
      this.isSending = true
      this.$recaptcha('contact').then(() => {
        axios.post('https://api.forum-ia.devbeet.com/wp-json/beet/v1/contact', this.model).then(success => {
          this.isSending = false
          if (!success) return console.error('An error occurred sending the email')
          this.isComplete = true
        })
      }).catch(() => {
        this.isSending = false
      })

    }
  }
}
</script>
